<div class="row">
    <div class="alert alert-danger saving-alert d-flex align-items-center" *ngIf="loading" role="alert" aria-live="assertive"
        aria-atomic="true">
        <i class="bi bi-exclamation-triangle-fill me-2" aria-hidden="true" style="font-size: 1.3rem; margin-right: 8px"></i>

        <span id="loading-message">
            Uno o più file sono in salvataggio, l'operazione potrebbe richiedere del tempo.
        </span>

        <div class="spinner-border text-light ms-2" role="status" aria-label="Caricamento in corso"
        style="width: 1.5rem; height: 1.5rem; margin-left: 8px">
        <span class="sr-only">Caricamento...</span>
        </div>
    </div>
</div>
<div class="row" style="position: relative;">
    <div class="col-sm-4">
        <div comboModInput 
            [labelInput]="'Modalità di formazione'"
            [(ngModel)]="modalitaFormazioneDocumento" 
            [labelNoSelection]="'Seleziona'"
            [optionsCombo]="modalitaFormazOptions" 
            [objectReference]="modalitaFormazioneDocumento"
            (onReturn)="onMassiveSelectChange($event, 'modalitaFormazioneDocumento')">
        </div>
    </div>
    <div class="col-sm-4"></div>
    <div class="col-sm-4">
        <div comboModInput 
            [labelInput]="'Tipologia Firma'"
            [(ngModel)]="motivoAssenzaFirma" 
            [labelNoSelection]="'Seleziona'"
            [optionsCombo]="firmaOptions" 
            [objectReference]="motivoAssenzaFirma"
            (onReturn)="onMassiveSelectChange($event, 'motivoAssenzaFirma')">
        </div>
    </div>
    
</div>
<!--TABELLA-->
<div class="table-container">
    <table *ngIf="documenti.length > 0" class="table-striped table aggiunta_classificazione" style="margin-top: 30px;">
        <caption class="sr-only">Lista documentazi formati</caption>
        <thead>
            <tr>
                <th scope="col" style="width: 20%">Nome File</th>
                <th scope="col" style="width: 25%">Tipo Documento</th>
                <th scope="col" style="width: 25%">Tipologia Firma</th>
                <th scope="col" style="width: 25%">Modalità formazione</th>
                <th scope="col" style="width: 10%" aria-label="Anteprima documento"></th>
                <th scope="col" style="width: 10%" aria-label="Selezione documenti">
                    <div style="text-align: center;" singleCheckBoxModInput [labelInput]="''"
                        [showLabel]="false" idInput="documento-select-all"
                        [objectReference]="selectedDocs.length === documenti.length"
                        (onReturn)="selectAll($event)">
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr class="borded" *ngFor="let doc of documentiPaged">
                <td>
                    {{ doc.nomeFile || '-'}}
                     <span *ngIf="hasFirmaNonValida(doc)"
                        class="glyphicon glyphicon-alert"
                        style="color: #d9534f; margin-left: 6px;"
                        aria-label="Firma non valida"
                        title="Firma non valida">
                    </span>
                </td>
                <td>
                    {{ doc.tipoDocumento.descrizione || '-'}}
                </td>
                <td>
                    <div comboModInput 
                        *ngIf="doc.metadatoFirmaDocumenti.length === 0 && !isArchive(doc)"
                        [(ngModel)]="doc.metadatoDocumento.motivoAssenzaFirma" 
                        [labelNoSelection]="'Seleziona'"
                        [optionsCombo]="firmaOptions" 
                        [objectReference]="doc.metadatoDocumento.motivoAssenzaFirma"
                        (onReturn)="onSelectChange($event, doc, 'motivoAssenzaFirma')">
                    </div>
                    <div *ngIf="!doc.metadatoDocumento!"> - </div>
                </td>
        
                <td style="text-align: center;">
                    <div comboModInput 
                        *ngIf="doc.metadatoDocumento"
                        [(ngModel)]="doc.metadatoDocumento.modalitaFormazioneDocumento" 
                        [labelNoSelection]="'Seleziona'"
                        [optionsCombo]="modalitaFormazOptions" 
                        [objectReference]="doc.metadatoDocumento.modalitaFormazioneDocumento"
                        (onReturn)="onSelectChange($event, doc, 'modalitaFormazioneDocumento')">
                    </div>
                    <div *ngIf="!doc.metadatoDocumento!"> - </div>
                </td>
                <td style="text-align: center;" *ngIf="isFilePresent(doc)">
                    <a *ngIf="canViewFile(doc)" aria-label="mostra anteprima documento" href="javascript:void(0)"
                        (click)="viewDoc(doc)">
                        <span class="glyphicon glyphicon-eye-open"></span>
                    </a>
                    <a *ngIf="!canViewFile(doc)" href="javascript:void(0)" aria-label="anteprima non disponibile"
                        [appTooltip]="'L’anteprima non è disponibile perché il file supera le dimensioni massime consentite'"
                        [appTooltipEnabled]="checkMaxLimitExceeded(doc)">
                        <span class="glyphicon glyphicon-eye-close"></span>
                    </a>
                </td>
                <td style="text-align: center;" *ngIf="!isFilePresent(doc)">
                    <a *ngIf="canViewFile(doc)">
                        <span class="glyphicon glyphicon-eye-open" style="opacity:0.5"></span>
                    </a>
                    <span *ngIf="!canViewFile(doc)" class="glyphicon glyphicon-eye-close" style="opacity:0.5"></span>
                </td>
                <td style="text-align: center;">
                    <div singleCheckBoxModInput [labelInput]="''"
                        [showLabel]="false" idInput="documento-selected-{{doc.id}}"
                        [objectReference]="doc?.selected"
                        (onReturn)="add({value:$event, document: doc})">
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div style="text-align: center;font-size: 18px;"
    *ngIf="!!documenti && documenti.length === 0; else documentListPagination">
    Non ci sono documenti caricati
</div>
<!--PAGINAZIONE-->
<ng-template #documentListPagination>
    <app-pagination [totalItems]="documenti.length" [resetCurrentPage]="false" [hasAutoRefresh]="false"
        [refreshOnChange]="true" (refreshEvent)="onRefresh($event)">
    </app-pagination>
</ng-template>
<div class="row" style="margin-top: 30px;">
    <div class="col-sm-3 col-xs-6">
        <button type="button" class="btn btn-block btn-secondary" (click)="reset()"> Reset </button>
    </div>
    <div class="col-sm-3 col-xs-6 col-sm-offset-6">
        <button type="button" class="btn btn-block btn-primary" [disabled]="selectedDocs.length === 0" (click)="save()"> Salva </button>
    </div>
</div>
